import React from 'react';
import ThemeCustomizer from './components/ThemeCustomizer';

function App() {
  return <ThemeCustomizer />;
}

export default App;